const DismantlingReducer = (state = {}, action) => {
    switch (action.type) {
        case "DISPRO_DOCS":
            return Object.assign({}, state, {
                Dispro_ListView: action.data
            });
        default:
            return state;
    }
};

export default DismantlingReducer;